module.exports = __webpack_public_path__ + "static/media/dryer.3462128b.svg";